<template>
  <v-dialog v-model="dialog.show"
            max-width="500px">
    <v-card class="py-2">
      <v-container>
        <v-row>
          <v-col cols="12"
                 class="text-h6">
            {{ dialog.title }}
          </v-col>
          <v-col cols="12">
            {{ dialog.text }}
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer />
          <v-btn outlined
                 title="NIE"
                 @click="dialog.show = false">
            NIE
          </v-btn>
          <v-btn color="primary"
                 :title="dialog.action || 'TAK'"
                 @click="onClickYes">
            {{ dialog.action || 'TAK' }}
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogYesNo",
  props: {
    dialog: {
      type: Object,
      default: function () {
        return {
          show: false,
          title: "Pytanie",
          text: "",
          action: '',
          callback: null,
          callbackData: null,
          noCallback: null,
          noCallbackData: null
        };
      }
    }
  },
  methods: {
    onClickYes: function () {
      if (this.dialog.callback) this.dialog.callback(this.dialog.callbackData);
      this.dialog.show = false;
    },
    onClickNo: function () {
      if (this.dialog.noCallback)
        this.dialog.noCallback(this.dialog.noCallbackData);
      this.dialog.show = false;
    }
  }
};
</script>
